import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';


export default function UtilisationDiary({}){
	
	const [thisMonth, setThisMonth] = useState("");
	const [thisYear, setThisYear] = useState("");
	const [tableRows, setTableRows] = useState([]);
	const days = ["S", "M", "T", "W", "T", "F", "S"];
	const months = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];
	
	const NON_DAY = "NON_DAY";
	const VALID_DAY = "VALID_DAY";
	
	useEffect(() => {
		let today = new Date();
		setThisMonth(months[today.getMonth() - 1]);
		today.setMonth(today.getMonth() - 1);
		today.setDate(1);
		setThisYear(today.getYear() + 1900);
		
		let tempTableRows = [];
		
		let currentMonth = today.getMonth();
		let dayCount = today.getDay();
		
		let rowDays = [];
		for(let i=0; i<dayCount; i++){
			rowDays.push({
				dateString:"",
				type:NON_DAY
			});
		}
		
		while(today.getMonth() === currentMonth){
			let rowAdded = false;
			if(today.getDay() === 0 || today.getDay() === 6){
				rowDays.push({
					dateString:today.getDate(),
					type:NON_DAY
				});
			}
			else{
				rowDays.push({
					dateString:today.getDate(),
					type:VALID_DAY
				});
			}
			
			if(today.getDay() === 6){
				let firstRow = {days:rowDays};
				tempTableRows.push(firstRow);
				rowAdded = true;
				rowDays = [];
			}
			
			today.setDate(today.getDate() + 1);
			if(today.getMonth() != currentMonth){
				let firstRow = {days:rowDays};
				tempTableRows.push(firstRow);
			}
		}
		
		
		console.log(tempTableRows);
		setTableRows(tempTableRows);
	}, []);
	
	
	const thisContainer = {
		display:'flex',
		width:"100%",
		flexDirection:"column",
		justifyContent:"space-around",
		marginTop:"20px"
	};
	
	const indicatorTitle = {
  	display:"flex",
  	alignItems:"center",
  	justifyContent:"space-around",
  	fontSize:"12px",
  	width:"100%",
  	fontWeight:"bold",
  	marginTop:"10px"
  };
  
  const mainRow = {
  	display:"flex",
  	width:"100%"
  };
  
  const arrowPanel = {
  	display:"flex",
  	width:"50px",
  	height:"100%",
  	alignItems:"center",
  	justifyContent:"space-around"
  };
  
  const arrowCircle = {
  	display:"flex",
  	width:"30px",
  	height:"30px",
  	borderRadius:"15px",
  	alignItems:"center",
  	justifyContent:"space-around",
  	cursor:'pointer',
  	boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)'
  };
  
  const arrow = {
  	display:"flex",
  	width:"20px",
  	height:"20px",
  	color:"darkgrey"
  };
  
  const displayTable = {
  	display:"flex",
  	width:"300px",
  	backgroundColor:"#eee",
  	minHeight:"80px",
  	alignSelf:"center",
  	flexDirection:"column"
  };
  
  const tableRow = {
  	display:"flex",
  	height:"20px",
  	alignItems:"center",
  	borderTop:"1px solid white"
  };
  
  const headerColumn = {
  	display:"flex",
  	width:"42px",
  	alignItems:"center",
  	justifyContent:"space-around",
  	borderRight:"1px solid white",
  	color:"black",
  	fontSize:"12px",
  	fontWeight:"bold",
  	height:"100%",
  	alignItems:"center",
  	backgroundColor:"#ddd"
  };
  
  const standardColumn = {
  	display:"flex",
  	width:"42px",
  	alignItems:"center",
  	justifyContent:"space-around",
  	borderRight:"1px solid white",
  	color:"black",
  	fontSize:"12px",
  	//fontWeight:"bold",
  	height:"100%",
  	alignItems:"center"
  };
  
  const getDayBackgroundColor = (dayItem) => {
  	if(dayItem.type === VALID_DAY){
  		return "rgba(255, 0, 0, " + Math.random() + ")";
  	}
  };
  
  const getTableColumnDisplay = (dayItem) => {
  	return <div style={{...standardColumn, backgroundColor:getDayBackgroundColor(dayItem)}}>
  		{dayItem.dateString}
  	</div>;
  };
  
  const headerDayDisplay = days.map((item, index) =>
  	<div style={headerColumn}>
			{item}
		</div>
  );
  
  const tableRowDisplay = tableRows.map((item, index) => 
  	<div style={tableRow}>
  		{item.days.map((dayItem, index) =>
  			getTableColumnDisplay(dayItem)	
  		)}
  	</div>
  ); 
	
	return (
		<div style={thisContainer}>
			<div style={mainRow}>
				<div style={arrowPanel}>
					<div style={arrowCircle}>
						<FontAwesomeIcon icon="angle-left" style={arrow}/>
					</div>
				</div>
				<div style={displayTable}>
					<div style={tableRow}>
						{headerDayDisplay}
					</div>
					{tableRowDisplay}
				</div>
				<div style={arrowPanel}>
					<div style={arrowCircle}>
						<FontAwesomeIcon icon="angle-right" style={arrow}/>
					</div>
				</div>
			</div>
			<div style={indicatorTitle}>
				Monthly Utilisation ({thisMonth}, {thisYear})
			</div>
		</div>
	);
}